import { CidadaoSelectFieldModel } from 'components/form'
import { Profissional } from 'graphql/types.generated'
import { createValidator, ErrorObject } from 'util/validation'

import { getCidadaoProfExistsMsg, hasSameCpfCns, hasSameId } from '../saude/utils-atividadeColetivaSaude'
import { CidadaoEditableTableModel } from './CidadaoEditableTable'
import { MSG_CIDADAO_JA_INCLUIDO } from './utils-atividadeColetivaGrupos'

export const cidadaoEditableTableValidator = (
  allItems: CidadaoEditableTableModel[],
  profissionaisEnvolvidos: Pick<Profissional, 'id' | 'cpf' | 'cns'>[]
) =>
  createValidator<CidadaoEditableTableModel>(
    {},
    (model: CidadaoEditableTableModel, errors: ErrorObject<CidadaoEditableTableModel>) => {
      errors.cidadao = validateInclusaoCidadao(model?.cidadao, allItems, profissionaisEnvolvidos)

      return errors
    }
  )

const validateInclusaoCidadao = (
  model: CidadaoSelectFieldModel,
  allItems: CidadaoEditableTableModel[],
  profissionaisEnvolvidos: Pick<Profissional, 'id' | 'cpf' | 'cns'>[]
) => {
  if (
    allItems?.some(
      (participante) => hasSameId(participante?.cidadao, model) || hasSameCpfCns(participante?.cidadao, model)
    )
  ) {
    return MSG_CIDADAO_JA_INCLUIDO
  }

  if (profissionaisEnvolvidos?.some((profissional) => hasSameCpfCns(profissional, model))) {
    return getCidadaoProfExistsMsg('envolvido')
  }

  return undefined
}
